export default "__VITE_ASSET__CCKHZTol__"